<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-06-23 20:29:17
 * @LastEditors: lau
 * @LastEditTime: 2022-07-20 11:54:11
-->
<!-- 续费线上月票接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
                "monthTicketConfigId": 4852,
                "parkCode": "2KKN6112"
            },
            responseCode: {
                "data": {}, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台根据月票类型取消线上月票",
                t_url: this.commonUrls.test + "cancelOnlineMonthTicketByMonthTicketType",
                p_url: this.commonUrls.prod + "cancelOnlineMonthTicketByMonthTicketType",
                precondition: "无",
                fitSystem: "云停车场,传统车场,路边车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'monthTicketConfigId', info2: '是', info3: 'Long', info4: '月票类型ID' },
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编号' }
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: []
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/cancelOnlineMonthTicketByMonthTicketType.vue